import AboutScreen from "../views/About"
import CaseStudyScreen from "../views/CaseStudy"
import ContactScreen from "../views/Contact"
// import Components from "../views/components/components"
// import CustomComponents from "../views/custom-components/custom-components"
import HomeScreen from "../views/Home"
import ProjectScreen from "../views/Project"
import ServicesScreen from "../views/Services"
import Fre8ProApplicationDetail from "../views/Fre8ProApplicationDetail"
import JobPortalDetail from "../views/JobPortalDetail"
import ViewBlogScreen from "../views/view-all-blog"
import ViewBlogDetailScreen from "../views/view-all-blog/blogDetails"
import IndustriesScreen from "../views/Industries"
import TechnologyScreen from "../views/Technology"
import FaqPageScreen from "../views/FaqPage"
import OurTeamScreen from "../views/OurTeam"
import CareersScreen from "../views/Careers"
import PrivacyPolicyScreen from "../views/PrivacyPolicy"
import TermsOfUseScreen from "../views/TermsOfUse"
// import userImgFRE8 from '../assets/images/team/FRE8-Logo-13.svg';
// import userImg1 from '../assets/images/blog/blog-home/b-01.webp';
// import bannerImg from './assets/images/project/project-banner.avif'
// import backgroundVideo from '/assets/images/landingpage/Hero-Banner.mp4'
// import { 
// AccountingIcon, 
// ECommerceIcon, 
// FacebookIcon, 
// FinanceIcon, 
// GovernmentIcon, 
// HealthIcon, 
// HotelAndRestaurantsIcon, 
// HRIcon, 
// InsuranceIcon, 
// JewelryIcon, 
// LMSIcon, 
// LogisticsIcon, 
// ManufacturingIcon, 
// NightClubDiscoBallIcon, 
// PharmaIcon, 
// TravelingAndTourismIcon
//  } from "../common/icons"
import EmailDisclaimerScreen from "../views/EmailDisclaimer"
import PersonaScreen from "../views/Persona"
import MobileAppDevelopmentScreen from "../views/mobileAppPage"
import WebAppDevelopmentScreen from "../views/WebAppPage"
import ECommerceApplicationsScreen from "../views/ECommercePage"
import EmergingTechnologiesServiceScreen from "../views/EmergingTechnologiesService"
import QualityAssuranceServiceScreen from "../views/QualityAssuranceService"
import UIAndUXDesignServiceScreen from "../views/UIAndUXDesignService"
import ProductEngineeringServicesScreen from "../views/ProductEngineeringServices"
// import { blogs } from "./BlogDetailsData"
import { FacebookIcon } from "../common/icons/facebookIcon"
import { AccountingIcon } from "../common/icons/accountingIcon"
import { ECommerceIcon } from "../common/icons/eCommerceIcon"
import { FinanceIcon } from "../common/icons/financeIcon"
import { GovernmentIcon } from "../common/icons/governmentIcon"
import { HealthIcon } from "../common/icons/healthIcon"
import { HotelAndRestaurantsIcon } from "../common/icons/hotelAndRestaurantsIcon"
import { HRIcon } from "../common/icons/hRIcon"
import { InsuranceIcon } from "../common/icons/insuranceIcon"
import { JewelryIcon } from "../common/icons/jewelryIcon"
import { LMSIcon } from "../common/icons/lMSIcon"
import { LogisticsIcon } from "../common/icons/logisticsIcon"
import { ManufacturingIcon } from "../common/icons/manufacturingIcon"
import { NightClubDiscoBallIcon } from "../common/icons/nightClubDiscoBallIcon"
import { PharmaIcon } from "../common/icons/pharmaIcon"
import { TravelingAndTourismIcon } from "../common/icons/travelingAndTourismIcon"
import EmailSignature from "../views/EmailSignature"
import Chatbot from "../views/CustomChatbotWithOpenAIAPI"
import LifeAtVarahiSoft from "../views/LifeAtVarahiSoft"
import AIAndMachineLearningServicesScreen from "../views/AIAndMachineLearningServices"

export const routesData = [
    {
        id: 1,
        path: '/',
        element: <HomeScreen title={'Home'} />,
        label: 'Home',
    },
    {
        id: 2,
        path: '/about',
        element: <AboutScreen title={'About'} />,
        label: 'About',
        children: [
            {
                id: 1,
                path: '/about',
                element: <AboutScreen title={'About'} />,
                label: 'About us',
            },
            {
                id: 2,
                path: '/our-team',
                element: <OurTeamScreen title={'Our Team'} />,
                label: 'Our team',
            },
            {
                id: 3,
                path: '/life-at-varahiSoft',
                element: <LifeAtVarahiSoft title={'Life At VarahiSoft'} />,
                label: 'Life At VarahiSoft',
            },
            {
                id: 3,
                path: '/view-all-blog',
                element: <ViewBlogScreen title={'view-all-blog'} />,
                label: 'Blogs',
            },
        ]
    },
    {
        id: 3,
        path: '/services',
        element: <ServicesScreen title={'Services'} />,
        label: 'Services',
        children: [
            {
                id: 1,
                path: '/services',
                element: <ServicesScreen title={'Services'} />,
                label: 'All Services',
            },
            {
                id: 1,
                path: '/services/mobile-app-development',
                element: <MobileAppDevelopmentScreen title={'Modern Mobile App Development Services for Global Clients'} />,
                label: 'Mobile App Development',
            },
            {
                id: 2,
                path: '/services/web-app-development',
                element: <WebAppDevelopmentScreen title={'Web App Development Services for Scalable Digital Solutions'} />,
                label: 'Web App Development',
            },
            {
                id: 3,
                path: '/services/e-commerce-applications',
                element: <ECommerceApplicationsScreen title={'E-commerce App Development Services for Online Growth'} />,
                label: 'E-commerce Applications',
            },
            {
                id: 4,
                path: '/services/emerging-technologies',
                element: <EmergingTechnologiesServiceScreen title={'Transformative Emerging Technology Solutions by VarahiSoft'} />,
                label: 'Emerging Technologies',
            },
            {
                id: 5,
                path: '/services/quality-assurance',
                element: <QualityAssuranceServiceScreen title={'Reliable Quality Assurance Services to Ensure Software Excellence'} />,
                label: 'Quality Assurance',
            },
            {
                id: 6,
                path: '/services/ui-and-ux-design',
                element: <UIAndUXDesignServiceScreen title={'Creative UI and UX Design Services for Web and Mobile Apps'} />,
                label: 'UI and UX Design',
            },
            {
                id: 7,
                path: '/services/product-engineering',
                element: <ProductEngineeringServicesScreen title={'Accelerate Innovation with VarahiSoft’s Product Engineering'} />,
                label: 'Product Engineering',
            },
            {
                id: 8,
                path: '/services/AI-Machine-Learning-Services',
                element: <AIAndMachineLearningServicesScreen title={'AI & Machine Learning Services'} />,
                label: 'AI & ML Services',
            },
        ]
    },
    {
        id: 4,
        path: '/project',
        element: <ProjectScreen title={'Project'} />,
        label: 'Project',
    },
    {
        id: 5,
        path: '/case-study',
        element: <CaseStudyScreen title={'Case Study'} />,
        label: 'Case Study',
    },
    {
        id: 6,
        path: '/case-study/fre8Pro-application',
        element: <Fre8ProApplicationDetail title={'Case Study'} />,
        label: 'Case Study',
        hidden: true,
    },
    {
        id: 7,
        path: '/case-study/job-portal',
        element: <JobPortalDetail title={'Case Study'} />,
        label: 'Case Study',
        hidden: true,
    },
    {
        id: 8,
        path: '/contact',
        element: <ContactScreen title={'Contact'} />,
        label: 'Contact',
    },
    // {
    //     id: 9,
    //     key: '/components',
    //     element: <Components title={'Components'} />,
    //     label: 'Components',
    // },
    // {
    //     id: 10,
    //     key: '/custom-components',
    //     element: <CustomComponents title={'Custom-Components'} />,
    //     label: 'Custom-Components',
    // },
    {
        id: 11,
        path: '/view-all-blog',
        element: <ViewBlogScreen title={'view-all-blog'} />,
        label: 'View all blog',
        hidden: true,
    },
    {
        id: 12,
        path: '/blog-detail/:slug',
        element: <ViewBlogDetailScreen title={'Blog Detail'} />,
        label: 'blog detail',
        hidden: true,
    },
    {
        id: 13,
        path: '/industries',
        element: <IndustriesScreen title={'Industries'} />,
        label: 'Industries',
        hidden: true,
    },
    {
        id: 14,
        path: '/technology',
        element: <TechnologyScreen title={'Technology'} />,
        label: 'Technology',
        hidden: true,
    },
    {
        id: 15,
        path: '/faq',
        element: <FaqPageScreen title={'FAQ'} />,
        label: 'FAQ',
        hidden: true,
    },
    {
        id: 16,
        path: '/our-team',
        element: <OurTeamScreen title={'Our Team'} />,
        label: 'Our Team',
        hidden: true,
    },
    {
        id: 17,
        path: '/careers',
        element: <CareersScreen title={'Careers'} />,
        label: 'Careers',
        hidden: true,
    },
    {
        id: 18,
        path: '/privacy-policy',
        element: <PrivacyPolicyScreen title={'Privacy Policy'} />,
        label: 'Privacy Policy',
        hidden: true,
    },
    {
        id: 19,
        path: '/terms-of-use',
        element: <TermsOfUseScreen title={'Terms of use'} />,
        label: 'Terms of use',
        hidden: true,
    },
    {
        id: 20,
        path: '/email-disclaimer',
        element: <EmailDisclaimerScreen title={'Email Disclaimer'} />,
        label: 'Email Disclaimer',
        hidden: true,
    },
    {
        id: 21,
        path: '/email-signature',
        element: <EmailSignature title={'Email Signature'} />,
        label: 'Email Signature',
        hidden: true,
    },
    {
        id: 22,
        path: '/persona',
        element: <PersonaScreen title={'Persona'} />,
        label: 'Persona',
        hidden: true,
    },
    {
        id: 23,
        path: '/services/mobile-app-development',
        element: <MobileAppDevelopmentScreen title={'Modern Mobile App Development Services for Global Clients'} />,
        label: 'Modern Mobile App Development Services for Global Clients',
        hidden: true,
    },
    {
        id: 24,
        path: '/services/web-app-development',
        element: <WebAppDevelopmentScreen title={'Web App Development Services for Scalable Digital Solutions'} />,
        label: 'Web App Development Services for Scalable Digital Solutions',
        hidden: true,
    },
    {
        id: 25,
        path: '/services/e-commerce-applications',
        element: <ECommerceApplicationsScreen title={'E-commerce App Development Services for Online Growth'} />,
        label: 'E-commerce App Development Services for Online Growth',
        hidden: true,
    },
    {
        id: 26,
        path: '/services/emerging-technologies',
        element: <EmergingTechnologiesServiceScreen title={'Transformative Emerging Technology Solutions by VarahiSoft'} />,
        label: 'Transformative Emerging Technology Solutions by VarahiSoft',
        hidden: true,
    },
    {
        id: 27,
        path: '/services/quality-assurance',
        element: <QualityAssuranceServiceScreen title={'Reliable Quality Assurance Services to Ensure Software Excellence'} />,
        label: 'Reliable Quality Assurance Services to Ensure Software Excellence',
        hidden: true,
    },
    {
        id: 28,
        path: '/services/ui-and-ux-design',
        element: <UIAndUXDesignServiceScreen title={'Creative UI and UX Design Services for Web and Mobile Apps'} />,
        label: 'Creative UI and UX Design Services for Web and Mobile Apps',
        hidden: true,
    },
    {
        id: 29,
        path: '/services/product-engineering',
        element: <ProductEngineeringServicesScreen title={'Accelerate Innovation with VarahiSoft’s Product Engineering'} />,
        label: 'Accelerate Innovation with VarahiSoft’s Product Engineering',
        hidden: true,
    },
    {
        id: 30,
        path: '/services/AI-Machine-Learning-Services',
        element: <AIAndMachineLearningServicesScreen title={'AI & ML Services'} />,
        label: 'AI & ML Services',
        hidden: true,
    },
    {
        id: 31,
        path: '/chat-bot',
        element: <Chatbot title={'Accelerate Innovation with VarahiSoft’s Product Engineering'} />,
        label: 'Accelerate Innovation with VarahiSoft’s Product Engineering',
        hidden: true,
    },
    {
        id: 32,
        path: '/life-at-varahiSoft',
        element: <LifeAtVarahiSoft title={'Life At VarahiSoft'} />,
        label: 'Life At VarahiSoft',
        hidden: true,
    },
    {
        id: 33,
        path: '*',
        element: <HomeScreen title={'Home'} />,
        label: 'Home',
        hidden: true,
    },
];

export const items = [
    {
        data: [
            {
                icon: <FacebookIcon />,
                text: 'Social Media',
                paragraph: 'Apps that connect with your loved ones the right way'
            },
            {
                icon: <ECommerceIcon />,
                text: 'E-commerce',
                paragraph: 'Connecting sellers and buyers and making sales'
            },
            {
                icon: <TravelingAndTourismIcon />,
                text: 'Traveling and Tourism',
                paragraph: 'Apps that are gateway to the world'
            },
            {
                icon: <HotelAndRestaurantsIcon />,
                text: 'Hotel and Restaurants',
                paragraph: 'Apps that work for your business to grow'
            },
        ]
    },
    {
        data: [
            {
                icon: <JewelryIcon />,
                text: 'Jewellery - Retail',
                paragraph: 'The apps that shine your business'
            },
            {
                icon: <ManufacturingIcon />,
                text: 'Manufacturing ',
                paragraph: 'Apps that streamline the process and automate'
            },
            {
                icon: <AccountingIcon />,
                text: 'Accounting',
                paragraph: 'Apps that give you the real picture'
            },
            {
                icon: <FinanceIcon />,
                text: 'Finance ',
                paragraph: 'Apps that give you more clarity'
            },
        ]
    },
    {
        data: [
            {
                icon: <InsuranceIcon />,
                text: 'Insurance',
                paragraph: 'Apps that delivers more protection'
            },
            {
                icon: <LMSIcon />,
                text: 'LMS',
                paragraph: 'Apps that makes learning easy'
            },
            {
                icon: <NightClubDiscoBallIcon />,
                text: 'Events',
                paragraph: 'Apps that conduct sans stress'
            },
            {
                icon: <LogisticsIcon />,
                text: 'Logistics and Transport',
                paragraph: 'Apps that connect the logistics industry'
            },
        ]
    },
    {
        data: [
            {
                icon: <HealthIcon />,
                text: 'Health Care',
                paragraph: 'Apps that are top notch'
            },
            {
                icon: <PharmaIcon />,
                text: 'Hospital and Pharma',
                paragraph: 'Apps that make lives easier'
            },
            {
                icon: <HRIcon />,
                text: 'Human Resources',
                paragraph: 'Apps that are people driven'
            },
            {
                icon: <GovernmentIcon />,
                text: 'Government',
                paragraph: 'Apps that are top notch'
            },
        ]
    }
];